export default __webpack_public_path__ + "images/bank-logos/handelsbanken.png";